import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import RedButton from 'components/buttons/RedButton';
import FormStepWrapper from 'components/form/FormStepWrapper';
import { useBecomeFundraiser } from 'features/my-profile/become-fundraiser/context/BecomeFundraiserProvider';
import { OrganizationFormData } from 'features/my-profile/become-fundraiser/form/components/add-organization/useAddOrganizationForm';
import { useAddOrganizationPopup } from 'features/my-profile/become-fundraiser/form/components/add-organization/useAddOrganizationPopup';
import ContactSupportButton from 'features/my-profile/become-fundraiser/form/components/ContactSupportButton';
import OrganizationSummary from 'features/my-profile/become-fundraiser/form/components/OrganizationSummary';
import { useSearchOrganizationsPopup } from 'features/my-profile/become-fundraiser/form/components/search-organization/useSearchOrganizationsPopup';

const Button = styled(RedButton)`
  height: 46px;
`;

const VerifyOrganization = () => {
  const { t } = useTranslation('myProfile');
  const { showOrganizationsPicker } = useSearchOrganizationsPopup();
  const { showAddOrganizationPopup } = useAddOrganizationPopup();
  const { formData, errors, setFieldValue } = useBecomeFundraiser();

  const onOrganizationSelected = (organization?: OrganizationFormData) => {
    setFieldValue('organization', organization);
  };

  return (
    <FormStepWrapper
      header={t('become-fundraiser.verify-organization.header')}
      description={t('become-fundraiser.verify-organization.description')}
      isNextHidden={!formData.organization}
      isValid={!errors.organization}>
      {!formData.organization && (
        <>
          <Button onClick={() => showOrganizationsPicker(onOrganizationSelected)}>
            {t('become-fundraiser.verify-organization.search-organizations')}
          </Button>
          <Button onClick={() => showAddOrganizationPopup(onOrganizationSelected)}>
            {t('become-fundraiser.verify-organization.add-organization-header')}
          </Button>
        </>
      )}
      {formData.organization && (
        <OrganizationSummary
          organization={formData.organization}
          onChangePress={() => onOrganizationSelected()}
          onEditPress={
            formData.organization.customOrganization
              ? () => showAddOrganizationPopup(onOrganizationSelected, formData.organization)
              : undefined
          }
        />
      )}
      <ContactSupportButton />
    </FormStepWrapper>
  );
};

export default VerifyOrganization;
